import React from 'react';
import { SelectBoxWrapper } from './selectBox.style';
import { TextField, IconButton, FormControl, Select, MenuItem } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

export interface ISelectBoxProps {
  input: boolean;
  value: string;
  label: string;
  placeholder: string;
  options: {
    value: string;
    name: string;
  }[];
  className?: string;
  onChange: (value: any) => void;
  isSelectEnv?: boolean;
}

const SelectBox = (props: ISelectBoxProps) => {
  const { value, label, placeholder, options, input, onChange, className, isSelectEnv } = props;

  return (
    <>
      <SelectBoxWrapper isInput={input} isSelectEnv={isSelectEnv} className={className} id="txt-admin-input">
        <FormControl variant="standard">
          {!!label && <span>{label}</span>}
          {input ? (
            <TextField
              variant="standard"
              value={value}
              placeholder={placeholder}
              onChange={(e) => onChange(e.target.value)}
              // press enter to submit
              onKeyDown={(e: any) => {
                if (e.key === 'Enter') {
                  onChange(e.target.value);
                }
              }}
              InputProps={{
                endAdornment: (!!value && 
                  <IconButton
                    aria-label="copy"
                    size="small"
                    onClick={() => onChange('')}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                )
              }}
            />
          ) : (
            <Select
              id="uptime-admin-select-box"
              value={value}
              onChange={(e) => onChange(e.target.value)}
            >
              {options.map((item: { value: string; name: string }) => (
                <MenuItem key={item?.value} value={item?.value}>{item?.name}</MenuItem>
              ))}
            </Select>
          )}
        </FormControl>
      </SelectBoxWrapper>
    </>
  )
};

export const defaultProps = {
  input: false,
  value: '',
  label: '',
  placeholder: '',
  className: '',
  options: [],
  onChange: () => { },
  isSelectEnv: false,
};

SelectBox.defaultProps = defaultProps;

export default SelectBox;
